import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const confirmOrderId = createUUID();

export const useScheduledOrderActionsViewModel = ({
  id: orderId,
  modifiedOn,
  onRefresh,
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const confirmOrder = (confirmedScheduleDate) => {
    stateManager.run(async () => {
      const response = await taskService.order.confirm({
        orderId,
        modifiedOn,
        data: {
          confirmedScheduleDate,
        },
        toastMessageConfig: {
          success: { text: "Order confirmed successfully" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        onRefresh();
      }
    }, confirmOrderId);
  };

  return {
    isLoading,
    confirmOrder,
  };
};
